import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-investment-asset-material-list',
  templateUrl: './investment-asset-material-list.components.html',
})
export class InvestmentAssetMaterialListComponent { }
